import dayjs from 'dayjs';
import Calendar from 'components/Calendar';
import { useCalendar } from 'hooks/useCalendar';
import { Spinner } from 'components/Loading';
import EmptyCalendar from './EmptyCalendar';

import './calendar-widget.scss';

const CalendarWidget = () => {
  const {
    projects,
    events,
    timeZone,
    integration,
    loginCalendarsById,
    isLoaded,
    displayDateTip,
    setDisplayDateTip,
    handleDateChange,
    refetchEvents,
  } = useCalendar({ fetchInitialEvents: true });

  const start = dayjs();
  const end = start.add(7, 'day');

  return (
    <div className="dashboard--calendar">
      {!isLoaded ? (<Spinner />) : (
        <Calendar
          projects={projects}
          events={events.filter(ev => ev.type !== 'payment_due' && ev.type !== 'checklist')}
          noEventsContent={() => <EmptyCalendar />}
          timeZone={timeZone}
          onDateChange={handleDateChange}
          refetchEvents={refetchEvents}
          integration={integration}
          loginCalendarsById={loginCalendarsById}
          displayDateTip={displayDateTip}
          setDisplayDateTip={setDisplayDateTip}
          initialView="list"
          displayEventEnd={false}
          listDayFormat={(calDate) => {
            const { day, month, year } = calDate.date;
            // The previous code added one to the month and concatenated the date string, which broke in Safari.
            // Instead, we can use dayjs to format the date correctly.
            return dayjs(new Date(year, month, day)).format('ddd, MMMM D');
          }}
          customEventContent={null}
          listDaySideFormat={() => ''}
          allDayText="All Day"
          visibleRange={{
            start: start.format('YYYY-MM-DD'),
            end: end.format('YYYY-MM-DD'),
          }}
          validRange={{
            start: start.format('YYYY-MM-DD'),
            end: end.format('YYYY-MM-DD'),
          }}
          height="auto"
          noHeader
          collapsed
        />
      )}
    </div>
  );
};

export default CalendarWidget;
